import { handle } from '../../../api/apiUtils';
const drupalUrl = '/api/drupal';
export const fetchBranchLocations = async ()=>{
    const res = await fetch(`${drupalUrl}/api/locations/all`);
    const temp = await handle(res);
    if (temp.kind != 'result') return temp;
    return {
        ...temp,
        value: temp.value
    };
};
